import { Box } from "@mui/material";
import ExportButton from "components/common/Export";
import { exportURLs } from "components/common/Export/ExportAPIEndpoints";
import { fetchmembersInfo } from "components/common/Filters/Filters.slice";
import { filterPage } from "components/common/Filters/FiltersHelper";
import GlobalFilterDescription from "components/common/Filters/GlobalFilterDescription";
import GlobalFilters from "components/common/Filters/GlobalFilters";
import ButtonLink from "components/common/Link";
import BasicTable from "components/common/Table";
import Typography from "components/common/Typography";
import { useTranslate } from "hooks/useTranslate";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { CORPORATE_USER, PAGE_SIZE } from "utils/CommonConstants";
import { formFilterRequestPayload } from "utils/CommonFunctions";
import { getUIFormatDate } from "utils/DateHelper";
import { serviceTypes } from "utils/Types";
import { fetchUserPermissionSummary, reset } from "./AdminConsole.slice";
import { headers } from "./TableHeadersConfig";
import "./index.scss";

const getMemberInfo = (el: any) => {
  const name = el.displayName || `${el.firstName || ""} ${el.lastName || ""}` || "-";
  return (
    <div>
      <Typography variant={"body2"} color={tokens.Text.General.PrimaryBody} showBold component={"div"}>
        {name}
      </Typography>
      <Typography variant="label" color={tokens.Text.General.PrimaryBody} component={"div"}>
        {el.email}
      </Typography>
      <Typography variant={"label"} color={tokens.Text.General.Tertiary} component={"div"}>
        {el.hltId}
      </Typography>
    </div>
  );
};

const getValue = (val: string) => {
  let value = "Disabled";
  if (val.toLowerCase() === "y") {
    value = "Enabled";
  } else if (val.toLowerCase() === "n") {
    value = "Disabled";
  }

  return value;
};

const AdminConsole = () => {
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const navigate = useNavigate();

  const [pageNo, setPageNo] = useState(0);
  const [isComponentLoad, setIsComponentLoad] = useState<boolean>(false);

  const userPermissions = useAppSelector((state) => state.adminConsole.userPermissions);
  const totalRecords = useAppSelector((state) => state.adminConsole.totalRecords);
  const sorting = useAppSelector((state) => state.sortingDetails.sorting);
  const recentSortingApplied = sorting?.["adminConsole"];

  const globalFiltersforPage = useAppSelector((state) => state.globalFilters[filterPage.adminConsoleDisplay]);
  const filterRequestPayload = globalFiltersforPage?.modifiedFilter || globalFiltersforPage?.defaultFilter || [];
  const formattedFilterRequestPayload = formFilterRequestPayload(filterRequestPayload);

  const getPayload = (page?: number) => {
    let payload = {
      pageable: {
        page: page ?? pageNo,
        size: PAGE_SIZE
      },

      sort: {
        ...recentSortingApplied
      },
      ...formattedFilterRequestPayload
    };
    return payload;
  };

  useEffect(() => {
    (async () => {
      await dispatch(fetchUserPermissionSummary({ payload: { ...getPayload(0) } }));
      setPageNo(0);
      setIsComponentLoad(true);
    })();
  }, [recentSortingApplied, filterRequestPayload]);

  useEffect(() => {
    if (pageNo > 0) dispatch(fetchUserPermissionSummary({ payload: { ...getPayload() } }));
  }, [pageNo]);

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, []);

  const getMembersList = (searchValue: string) => {
    const props: any = {
      searchText: searchValue,
      userType: CORPORATE_USER,
      page: 0,
      size: 100
    };
    dispatch(fetchmembersInfo(props));
  };

  return (
    <>
      <div className="admin-console-component">
        <div className="admin-console-header">
          <div className="admin-console-header-text">
            <Typography variant={"h4"} showBold color={tokens.Icon.General.Primary}>
              {translate("adminConsole.header")}
            </Typography>
          </div>
          <Box className="admin-console-header-filter">
            <GlobalFilters page={filterPage.adminConsoleDisplay} getMembersList={getMembersList} />
          </Box>
        </div>
        <GlobalFilterDescription page={filterPage.adminConsoleDisplay} />
        <div className="export-icon">
          <ExportButton
            URL={exportURLs.admin_console}
            data={{
              sort: { ...recentSortingApplied },
              ...formattedFilterRequestPayload
            }}
            serviceType={serviceTypes.user}
          />
        </div>
        {isComponentLoad && (
          <div id="adminConsoleDiv" className="admin-console-table">
            <BasicTable
              pagination={{ pageNo, setPageNo }}
              totalRecords={totalRecords}
              noDataMessage={translate("common.noMemberFound")}
              scrollableTarget="adminConsoleDiv"
              tableName="adminConsole"
              data={{
                headers: headers,
                rows: userPermissions?.map((element: any) => {
                  return {
                    data: [
                      { content: getMemberInfo(element) },
                      { content: element.userType ?? "Corporate" },
                      { content: element.templatePlansAccess },
                      { content: element.permission ?? "View" },
                      { content: getValue(element.adminConsoleAccess) },
                      { content: element.uploadRecommendationAccess },
                      { content: element.region },
                      { content: getUIFormatDate(element.lastLoggedInDate) },
                      {
                        content: (
                          <ButtonLink
                            text={
                              <Typography variant={"label"} showBold>
                                Edit
                              </Typography>
                            }
                            textVariant="body2"
                            underline="none"
                            sx={{ color: tokens.Text.General.Color }}
                            onClick={() =>
                              navigate("/editPermission", {
                                state: { userPermissionDetail: element }
                              })
                            }
                          />
                        )
                      }
                    ]
                  };
                })
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default AdminConsole;
